import {  ADD_QUESTION, ADD_QUESTION_SUCCESS, ADD_QUESTION_ERROR, QUESTION_LIST, QUESTION_LIST_SUCCESS, QUESTION_LIST_ERROR, QUESTION_DETAILS, QUESTION_DETAILS_SUCCESS, QUESTION_DETAILS_ERROR, DELETE_QUESTION, DELETE_QUESTION_SUCCESS, DELETE_QUESTION_ERROR, ASSET_TYPE_LIST, ASSET_TYPE_LIST_SUCCESS, ASSET_TYPE_LIST_ERROR, ADD_ASSET_TYPE, ADD_ASSET_TYPE_SUCCESS, ADD_ASSET_TYPE_ERROR, EDIT_ASSET_TYPE, EDIT_ASSET_TYPE_SUCCESS, EDIT_ASSET_TYPE_ERROR, ASSET_TYPE_DETAILS, ASSET_TYPE_DETAILS_SUCCESS, ASSET_TYPE_DETAILS_ERROR, DELETE_ASSET_TYPE_SUCCESS, DELETE_ASSET_TYPE_ERROR, DELETE_ASSET_TYPE } from './constants';


export default function retrainingDataReducer(state, action) {
    
	let assetType = [];
	let questions = [];

	switch (action.type) {

	case ASSET_TYPE_LIST:
		return { ...state, loading : true, error : false};

	case ASSET_TYPE_LIST_SUCCESS:
		if(action?.payload){
			action.payload.map((item) => {
                
				assetType.push({
					id : item.id,
					name : item.name
				});
			});
		}

		return {...state, assetType : assetType,  loading : false, error : false};

	case ASSET_TYPE_LIST_ERROR:
		return { ...state, assetType : [], loading : false, error : true};

	case ADD_ASSET_TYPE:
		return { ...state, loading: true };
	case ADD_ASSET_TYPE_SUCCESS:
		return { ...state, loading: false, error: false };

	case ADD_ASSET_TYPE_ERROR:
		return {...state, loading : false, error : true};

	case EDIT_ASSET_TYPE:
		return { ...state, loading: true, error: false };

	case EDIT_ASSET_TYPE_SUCCESS:
		return { ...state,  loading: false, error : false };

	case EDIT_ASSET_TYPE_ERROR:
		return {...state, loading : false, error : true};

	case ASSET_TYPE_DETAILS:
		return { ...state, loading: true };

	case ASSET_TYPE_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };

	case ASSET_TYPE_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_ASSET_TYPE:
		return { ...state, loading: false };

	case DELETE_ASSET_TYPE_SUCCESS:
		return { ...state, loading: false, error: false };

	case DELETE_ASSET_TYPE_ERROR:
		return { ...state, loading: false, error: true };

	case ADD_QUESTION:
		return { ...state, loading: true };

	case ADD_QUESTION_SUCCESS:
		return { ...state, loading: false, error: false };

	case ADD_QUESTION_ERROR:
		return {...state, loading : false, error : true};

	case QUESTION_LIST:
		return { ...state, loading : true, error : false};

	case QUESTION_LIST_SUCCESS:
		if(action?.payload){
			action.payload.map((item) => {
                
				questions.push({
					id : item.id,
					text : item.text
				});
			});
		}

		return {...state, questions : questions,  loading : false, error : false};
    
	case QUESTION_LIST_ERROR:
		return { ...state, batch : [], loading : false, error : true};

	case QUESTION_DETAILS:
		return { ...state, loading: true };


	case QUESTION_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };


	case QUESTION_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_QUESTION:
		return { ...state, loading: false };

	case DELETE_QUESTION_SUCCESS:
		return { ...state, loading: false, error: false };

	case DELETE_QUESTION_ERROR:
		return { ...state, loading: false, error: true };

	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}